import React from 'react';

import { Image } from '@uncinc/uncinc-react-kitchen-sink';

import constructVariableRatiosImageSourcesObject from '../../../../../helpers/constructImageSources';
import NodeProjectCard from '../../../../../implementations/Node/Project/Card';
import type { SearchAllContentProjectHit } from '../../../../SearchAllContent/types';

const MetaSearchProjectHit: React.FC<{ hit: SearchAllContentProjectHit }> = ({ hit }) => (
  <NodeProjectCard
    title={hit.page_title[0]}
    subtitle={hit.body_summarized?.[0] || hit.body?.[0] || hit.paragraphs_body_processed?.[0]}
    image={hit.image_ratio_1_1_xs?.[0] && (
      <Image
        src={constructVariableRatiosImageSourcesObject(
          hit,
          ['16_9', '1_1', '4_3', '4_3', '4_3'],
          ['sm', 'xxs', 'xs', 'sm', 'sm'],
        )}
        alt=""
        lazyload={false}
      />
    )}
    link={hit.url[0]}
    themes={hit.themes_name}
    durationStartDate={hit.project_duration_start_date?.[0]}
    durationEndDate={hit.project_duration_end_date?.[0]}
    researchLeader={hit.project_research_leader_name?.[0]}
    langcode={hit.langcode[0]}
  />
);

export default MetaSearchProjectHit;
